import { render, staticRenderFns } from "./PowerbiAdmin.vue?vue&type=template&id=15e697d0"
import script from "./PowerbiAdmin.vue?vue&type=script&lang=js"
export * from "./PowerbiAdmin.vue?vue&type=script&lang=js"
import style0 from "./PowerbiAdmin.vue?vue&type=style&index=0&id=15e697d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports